@if (text) {
  <!--  Use class accredible-rich-text-wrapper if text is HTML to apply the proper styles -->
  <div [innerHTML]="text"
    [class.accredible-rich-text-wrapper]="isTextHtml">
  </div>
}
